/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { BulkSaleDetailRequestDto } from '../model/bulkSaleDetailRequestDto';
import { BulkSaleLatestWeightInResponseDto } from '../model/bulkSaleLatestWeightInResponseDto';
import { BulkSaleRequestDto } from '../model/bulkSaleRequestDto';
import { PurchaseDetailResponseDto } from '../model/purchaseDetailResponseDto';
import { PurchaseDetailUpdateRequestDto } from '../model/purchaseDetailUpdateRequestDto';
import { PurchasePaginationResponseDto } from '../model/purchasePaginationResponseDto';
import { PurchasePaidRequestDto } from '../model/purchasePaidRequestDto';
import { PurchaseRejectRequestDto } from '../model/purchaseRejectRequestDto';
import { PurchaseResponseDto } from '../model/purchaseResponseDto';
import { ValidationError } from '../model/validationError';

export enum purchasesGetStatusEnum {
  pending_bulk_sale = 'pending_bulk_sale',
  pending_review = 'pending_review',
  pending_payment = 'pending_payment',
  paid = 'paid',
  rejected = 'rejected',
}
export enum purchasesGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class PurchasesService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public purchasesBulkSaleDetailIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/purchases/bulk-sale/detail/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesBulkSaleDetailPost$(body: BulkSaleDetailRequestDto): Observable<PurchaseResponseDto> {
    return this.api.post(`${apiBaseUrl()}/purchases/bulk-sale/detail`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesBulkSaleIdApprovePost$(id: string): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/purchases/bulk-sale/${encodeURIComponent(String(id))}/approve`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesBulkSaleLatestWeightInIdGet$(id: string): Observable<BulkSaleLatestWeightInResponseDto> {
    return this.api.get(`${apiBaseUrl()}/purchases/bulk-sale/latest-weight-in/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesBulkSalePost$(body: BulkSaleRequestDto): Observable<PurchaseResponseDto> {
    return this.api.post(`${apiBaseUrl()}/purchases/bulk-sale`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesGet$(page?: number, limit?: number, seller?: string, wpnBranchId?: string, franchiseBranchId?: string, memberId?: string, memberName?: string, purchaseNo?: string, fromDate?: string, toDate?: string, sumAmountMin?: number, sumAmountMax?: number, recordedBy?: string, approvedBy?: string, cashier?: string, status?: Array<string>, language?: string, isBulkSale?: boolean, sort?: string): Observable<PurchasePaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/purchases`, { page, limit, seller, wpnBranchId, franchiseBranchId, memberId, memberName, purchaseNo, fromDate, toDate, sumAmountMin, sumAmountMax, recordedBy, approvedBy, cashier, status, language, isBulkSale, sort });
  }
  /**
   * [Authorize] type: http
   */
  public purchasesIdApprovePost$(id: string): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/purchases/${encodeURIComponent(String(id))}/approve`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesIdDetaildetailIdPut$(id: string, detailId: string, body: PurchaseDetailUpdateRequestDto): Observable<PurchaseDetailResponseDto> {
    return this.api.put(`${apiBaseUrl()}/purchases/${encodeURIComponent(String(id))}/detail/${encodeURIComponent(String(detailId))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesIdGet$(id: string): Observable<PurchaseResponseDto> {
    return this.api.get(`${apiBaseUrl()}/purchases/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesIdPaidPost$(id: string, body: PurchasePaidRequestDto): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/purchases/${encodeURIComponent(String(id))}/paid`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public purchasesIdRejectPost$(id: string, body: PurchaseRejectRequestDto): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/purchases/${encodeURIComponent(String(id))}/reject`, body, undefined);
  }
}
